import React, { useState, useEffect } from 'react';
import { trackEvent, EVENTS } from '../../lib/analyticsV2';

const HeroV2 = () => {
  const handlePrimaryClick = () => {
    trackEvent(EVENTS.HERO_CTA_CLICK, {
      cta_id: 'primary_diagnostic',
      page_version: 'v2'
    });
  };

  const handleSecondaryClick = () => {
    trackEvent(EVENTS.HERO_CTA_CLICK, {
      cta_id: 'secondary_method',
      page_version: 'v2',
      headline_variant: variant
    });
  };

  const [variant, setVariant] = useState('A');

  useEffect(() => {
    let currentVariant = localStorage.getItem('ab_test_headline');
    if (!currentVariant) {
      currentVariant = Math.random() > 0.5 ? 'B' : 'A';
      localStorage.setItem('ab_test_headline', currentVariant);
    }
    setVariant(currentVariant);

    trackEvent(EVENTS.EXPERIMENT_EXPOSURE, {
      experiment_id: 'hero_headline_v1',
      variant: currentVariant
    });
  }, []);

  const headline = variant === 'A' 
    ? "Um plano patrimonial claro para transformar objetivos de longo prazo em decisões conscientes."
    : "Patrimônio não começa na escolha do produto, mas na clareza do seu objetivo.";

  return (
    <section className="relative overflow-hidden bg-background pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="container px-4 md:px-6 max-w-5xl mx-auto text-center">
        <div className="space-y-6">
          <div className="inline-block rounded-lg bg-muted px-3 py-1 text-sm font-medium tracking-widest text-muted-foreground uppercase">
            Planejamento Patrimonial Individual
          </div>
          
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl md:text-6xl text-foreground">
            {headline}
          </h1>
          
          <p className="mx-auto max-w-[800px] text-lg sm:text-xl text-muted-foreground leading-relaxed">
            Analisamos seu objetivo, prazo, fluxo de caixa, liquidez, custos e riscos para comparar alternativas como consórcio e imóveis antes de qualquer recomendação.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <a 
              href="#diagnostico" 
              onClick={handlePrimaryClick}
              className="inline-flex h-12 w-full sm:w-auto items-center justify-center whitespace-nowrap rounded-md bg-primary px-8 text-base font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
            >
              Fazer diagnóstico patrimonial
            </a>
            
            <a 
              href="#metodo" 
              onClick={handleSecondaryClick}
              className="inline-flex h-12 w-full sm:w-auto items-center justify-center whitespace-nowrap rounded-md border border-input bg-background px-8 text-base font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
            >
              Conhecer o método
            </a>
          </div>

          <p className="text-xs text-muted-foreground max-w-xl mx-auto pt-2">
            Sem promessa de contemplação, rentabilidade ou prazo. Você recebe contexto para decidir com mais clareza.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroV2;
